import Dashboard from "views/Dashboard.js";
import Notifications from "views/Notifications.js";
import ProductList from "views/ProductList";
import UsersList from "views/UsersList";
import OrderList from "views/OrderList";
import CategoryList from "views/CategoryList";
import UserPage from "views/User.js";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "nc-icon nc-bank",
    component: Dashboard,
    layout: "/admin",
  },

  {
    path: "/notifications",
    name: "Notifications",
    icon: "nc-icon nc-bell-55",
    component: Notifications,
    layout: "/admin",
  },
  {
    path: "/user-page",
    name: "User Profile",
    icon: "nc-icon nc-single-02",
    component: UserPage,
    layout: "/admin",
  },
  {
    path: "/usersList",
    name: "Users List",
    icon: "nc-icon nc-tile-56",
    component: UsersList,
    layout: "/admin",
  },
  {
    path: "/productList",
    name: "Product List",
    icon: "nc-icon nc-tile-56",
    component: ProductList,
    layout: "/admin",
  },
  {
    path: "/orderList",
    name: "Order List",
    icon: "nc-icon nc-tile-56",
    component: OrderList,
    layout: "/admin",
  },
  {
    path: "/categoryList",
    name: "Category List",
    icon: "nc-icon nc-tile-56",
    component: CategoryList,
    layout: "/admin",
  },
];
export default routes;
